export class Masker {
    strategy: IMaskingStrategy;

    constructor() {
        this.strategy = new DefaultStrategy();
    }

    public setStrategy(strategy: IMaskingStrategy) {
        this.strategy = strategy;
    }

    public mask(value: string) {
        return this.strategy.mask(value);
    }
}

export interface IMaskingStrategy {
    mask(valueToMask: string): string;
}

export class FixedNumberOfCharsMaskedFromTheBegining implements IMaskingStrategy {

    constructor(private charsToShow: number) { }

    public mask(value: string) {
        if (value.length > this.charsToShow) {
            return _mask(value, this.charsToShow);
        } else {
            return value;
        }

    }
}

export class FixedNumberOfCharsMaskedFromEnd implements IMaskingStrategy {
    constructor(private charsToShow: number) {
    }

    public mask(value: string) {
        if (value.length > this.charsToShow) {
            return _maskReverse(value, this.charsToShow);
        } else {
            return value;
        }
    }
}

export class DefaultStrategy implements IMaskingStrategy {
    public mask(value: string) {
        return value;
    }
}

export function mask(value: string): string {
    if (value && value.length > 0) {
        switch (value.length) {
            case 1:
                return value;

            case 2:
                return _mask(value, 1);

            case 3:
                return _mask(value, 2);

            case 4:
                return _mask(value, 2);

            default:
                return _mask(value, 3);
        }
    } else {
        return value;
    }
}

function _mask(value: string, visibleCharacters: number) {
    const replaced = value.replace(/./g, '*');
    return `${value.slice(0, visibleCharacters)}${replaced.slice(visibleCharacters)}`;
}

function _maskReverse(value: string, visibleCharacters: number) {
    const replaced = value.replace(/./g, '*');
    return `${replaced.slice(0, value.length - visibleCharacters)}${value.slice(value.length - visibleCharacters)}`;
}
